import MainLayout from '../main';
import RepLayout from '../rep-layout/rep-layout';
import EmptyLayout from '../empty';
import {check} from '../../../utils/tokenUtils';

// Rendered as a <Route> element from app.jsx; picks the layout at runtime. The chosen
// layout sources its own match/location via the withRouter shim / router hooks.
const ContentLayout = ({ rep, ...props }) => {
  const Layout = rep ? RepLayout : MainLayout;

  return check() ? <Layout private {...props} /> : <EmptyLayout {...props} />;
};

export default ContentLayout;
